import React from 'react';
import { useForm, SubmitHandler, FieldValues } from 'react-hook-form';
import {
  useApiClient,
  useFetch,
} from '@marageti/z4-lib';
import { useSnackbar } from 'notistack';
import { TeamMember } from '@marageti/z4-sdk/lib/people';
import { ApiError } from '@marageti/z4-sdk/lib/tracking';
import EditUserFormView from './edit-user-form-view';
import { useAuthStore } from '../../../store';
import { ContainerProps } from './types';

const EditUserFormContainer = ({
  open,
  onClose,
}: ContainerProps) => {
  const { enqueueSnackbar } = useSnackbar();
  const [submissionError, setSubmissionError] = React.useState<ApiError>();
  const apiClient = useApiClient();
  const { loggedInTeamMember } = useAuthStore();
  const teamMemberId = loggedInTeamMember?.id;

  const { data: teamMember, mutate } = useFetch<TeamMember>(apiClient.peopleClient.getTeamMember, [teamMemberId], !!teamMemberId);

  const {
    register,
    control,
    handleSubmit,
    formState: { errors, isSubmitting, isValid },
    reset,
  } = useForm({
    mode: 'onChange',
  });

  const handleCancel = () => {
    reset();
    onClose();
  };

  const onSubmit: SubmitHandler<FieldValues> = async (data) => {
    if (teamMember && teamMemberId) {
      const updatedTeamMember = {
        ...teamMember,
        ...data,
      };
      try {
        await apiClient.peopleClient.putTeamMember(teamMember.id, updatedTeamMember);
        enqueueSnackbar('Profile updated.', { variant: 'success' });
        mutate();
        onClose();
      } catch (error) {
        setSubmissionError(error as ApiError);
        enqueueSnackbar('An error occurred during the update.', { variant: 'default' });
      }
    }
  };

  return (
    <EditUserFormView
      control={control}
      errors={errors}
      handleSubmit={handleSubmit}
      isSubmitting={isSubmitting}
      isValid={isValid}
      onCancel={handleCancel}
      onSubmit={onSubmit}
      open={open}
      register={register}
      submissionError={submissionError}
      teamMember={teamMember}
    />
  );
};

export default EditUserFormContainer;
